module.exports = __webpack_public_path__ + "img/ic_64_progress.3e4dc227.svg";